import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'app-new-change-origin-and-destination',
  templateUrl: './new-change-origin-and-destination.component.html',
  styleUrls: ['./new-change-origin-and-destination.component.scss']
})
export class NewChangeOriginAndDestinationComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() BookingId:any;
  userId:any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  TenantId: any;
  @Output() OnRefreshParent = new EventEmitter<string>();

  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    isValueBind: true
  };

  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: false,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  PickupLocation: any = {
    lable: 'From Location',
    formControlName: 'PickupLocation',
    dataField: 'PickupLocation',
    isRequired: true,
    placeholder: 'Select From Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  DeliveryLocation: any = {
    lable: 'To Location',
    formControlName: 'DeliveryLocation',
    dataField: 'DeliveryLocation',
    isRequired: true,
    placeholder: 'Select To Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ContainerNo: any = {
    lable: 'Container No',
    formControlName: 'ContainerNo',
    dataField: 'ContainerNo',
    isRequired: true,
    placeholder: 'Enter Container No',
  };

  Scan: any = {
    lable: 'Scan',
    formControlName: 'Scan',
    dataField: 'Scan',
    isRequired: false,
    placeholder: 'Enter Scan',
  };

  TripDate: any = {
    lable: 'Trip Date',
    formControlName: 'TripDate',
    dataField: 'TripDate',
    isRequired: true,
    placeholder: 'Select Trip Date',
  };

  DieselTaken: any = {
    lable: 'Diesel Taken',
    formControlName: 'DieselTaken',
    dataField: 'DieselTaken',
    isRequired: false,
    placeholder: 'Enter Diesel Taken',
    type: "number",
  };

  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: false,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  data: any = {};
  isFormSubmitY: boolean = false;

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")))
    );
    this.GetTransportService();
    this.GetDmrDataById();
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  GetDmrDataById() {
    this._appService
      .GetById("Booking", "NewGetDMRDataById", this.BookingId)
      .subscribe(
        (response) => {
          console.log('GetDmrDataById response',response)
          if(response){
            this.data[this.TransportService.dataField]=response[0].TransportServiceId;
            this.data[this.VehicleType.dataField]=response[0].VehicleTypeId;
            this.data[this.PickupLocation.dataField]=response[0].Origin;
            this.data[this.DeliveryLocation.dataField]=response[0].Destination;
            this.data[this.VehicleNo.dataField]=response[0].VehicleId;
            this.data[this.ContainerNo.dataField]=response[0].ContainerNo;
            this.data[this.TripDate.dataField]=response[0].TripDate;
            this.data[this.Scan.dataField]=response[0].Scan;
            this.data[this.DieselTaken.dataField]=response[0].DieselTaken;
            this.data[this.Driver.dataField]=response[0].DriverId;
            this.data.VehicleNoText=response[0].VehicleNo;

            // this.setDropdown(this.TransportService,response[0].TransportServiceId,response[0].TransportService);
            this.setDropdown(this.VehicleType,response[0].VehicleTypeId,response[0].VehicleType);
            this.setDropdown(this.VehicleNo,response[0].VehicleId,response[0].VehicleNo);
            this.setDropdown(this.PickupLocation,response[0].Origin,response[0].Origin);
            this.setDropdown(this.DeliveryLocation,response[0].Destination,response[0].Destination);
            this.setDropdown(this.Driver,response[0].DriverId,response[0].DriverName);
            this.GetTransportService();
          }
        },
        (error)=>{
          this.toastr.error('Failed to load Origin–Destination data.','Error');
        }
      );
  }

  setDropdown(control: any, value: any, name: any) {
    control.dropdownList = [{
      value,
      name
    }];
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then(
    (res) => {
      this.TransportService.dropdownList = [];
      this.TransportService.dropdownList = res;
    })
    .catch((error) => {
      console.log(error);
    });
  }

  GetVehicleType(value, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this.orderService.GetVehicleTypeselect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
        this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] });
      this.VehicleType.isSearch = false;
    }).catch(error => {
      this.VehicleType.isSearch = false;
    })
  }

  GetPickupLocationList(value, isScrollDown = false) {
    this.PickupLocation.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.PickupLocation.dropdownList.length / 20) + 1;
    }
    this.orderService.NewGetOriginDestination(value, 'Origin').then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.PickupLocation.dropdownList.length) {
        dropdownList = dropdownList.concat(this.PickupLocation.dropdownList);
        this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] });
      this.PickupLocation.isSearch = false;
    }).catch(error => {
      this.PickupLocation.isSearch = false;
    })
  }

  GetDeliveryLocationList(value, isScrollDown = false) {
    this.DeliveryLocation.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.DeliveryLocation.dropdownList.length / 20) + 1;
    }
    this.orderService.NewGetOriginDestination(value, 'Destination').then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.DeliveryLocation.dropdownList.length) {
        dropdownList = dropdownList.concat(this.DeliveryLocation.dropdownList);
        this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] });
      this.DeliveryLocation.isSearch = false;
    }).catch(error => {
      this.DeliveryLocation.isSearch = false;
    })
  }

  GetVehicleList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 20) + 1;
    }
    this.orderService.NewVehicleNoSelect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 20) + 1;
    }
    this.orderService.GetDriverListFromOpRept(value, pageNo,this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  getChangedValue(value, data){
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if(value){
      if(
          data.dataField === 'TransportService' || 
          data.dataField === 'ContainerNo'||
          data.dataField === 'TripDate'||
          data.dataField === 'Scan'
        )
      {
        this.data[data.dataField] = value;
      } else if(data.dataField === 'VehicleNo'){
        this.data[data.dataField] = value.value;
        this.data.VehicleNoText = value.text;
      } else if(data.dataField === 'DieselTaken'){
        this.data[data.dataField] = Number(value);
      } else{
        this.data[data.dataField] = value.value;
      }
    } else{
      this.data[data.dataField] = null;
      this.data.VehicleNoText = null;
    }
  }

  Save() {
    this.isFormSubmitY=true;
    if(!this.data.TransportService){
      this.toastr.warning('Please Select Transport Service','Warning');
      return;
    }
    if(!this.data.PickupLocation){
      this.toastr.warning('Please Select From Location','Warning');
      return;
    }
    if(!this.data.DeliveryLocation){
      this.toastr.warning('Please Select To Location','Warning');
      return;
    }
    if(!this.data.VehicleNoText){
      this.toastr.warning('Please Select Vehicle No','Warning');
      return;
    }
    if(!this.data.ContainerNo){
      this.toastr.warning('Please enter Container No','Warning');
      return;
    }
    if(!this.data.TripDate){
      this.toastr.warning('Please select Trip Date','Warning');
      return;
    }
    // Helpers.setLoading(true);
    if (this.data.ContainerNo) {
      var patternCRT = new RegExp('^[a-zA-Z]{4}[0-9]{7}$');
      var resultCRT = patternCRT.test(this.data.ContainerNo);
      if (!resultCRT) {
        this.toastr.warning('Container no should contain 4 alphabets and 7 numbers in order', 'Warning');
        return;
      }
    }
    var obj: any = {};
    obj.BookingId = this.BookingId;
    obj.TransportServiceId = this.data.TransportService;
    obj.Origin = this.data.PickupLocation;
    obj.Destination = this.data.DeliveryLocation;
    obj.ContainerNo = this.data.ContainerNo;
    obj.Scan = this.data.Scan;
    obj.VehicleNo = this.data.VehicleNoText;
    obj.VehicleTypeId = this.data.VehicleType;
    obj.DieselTaken = this.data.DieselTaken;
    obj.DriverId = this.data.Driver;
    obj.TripDate = this.data.TripDate;
    obj.UserId = this.userId;
    console.log('Save obj:',obj);
    this._appService.Post("Booking", "NewUpdateDMROriginDestination", obj).subscribe(
      (response) => {
        Helpers.setLoading(false);
        this.toastr.success("Details saved Successfully !","Success");
        this.OnRefreshParent.emit('true');
        this.Cancel();
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error occurred while saving data !","error");
      }
    );
  }

}
